import { SxProps, Theme, Tooltip } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const TooltipLogisticCompany = ({ sxIcon = {}, icon }: { sxIcon?: SxProps<Theme>; icon?: JSX.Element }) => {
  return (
    <Tooltip
      arrow
      placement="top"
      title="Some importers/exporters use third-party logistics firms to place orders, removing their company name from official records. The logistics firm may not be the actual buyer or supplier."
    >
      {icon || <InfoOutlinedIcon color="action" sx={{ fontSize: 16, ...sxIcon }} />}
    </Tooltip>
  );
};

export default TooltipLogisticCompany;
